// extracted by mini-css-extract-plugin
module.exports = {"allFilters":"Order_allFilters__1RH7J","score":"Order_score__1D9E0","alphabetical":"Order_alphabetical__r2MJ-","button":"Order_button__jGkFU"};